import { useRef } from "react";
import { BACKEND } from "../config/configEnvs";
import axios from "axios";
import { toast } from "react-toastify";

const HandleUpdateText = (field, newValue, targetID, route, debounceUpdate, setElements = null) => {
  // Actualizar el estado localmente antes de la petición

  if (setElements) {
    setElements((P) =>
      P.map((e) =>
        e.id === targetID
          ? {
              ...e,
              [field]: newValue,
            }
          : e
      )
    );
  }

  if (debounceUpdate.current) {
    clearTimeout(debounceUpdate.current);
  }

  // Configurar nuevo debounce
  debounceUpdate.current = setTimeout(async () => {
    try {
      await axios.put(`${BACKEND}/api/${route}/${targetID}`, {
        [field]: newValue,
      });

    } catch (e) {
      toast.error("Error al actualizar el dato: " + e);
    }
  }, 1000); // Esperar 2 secs luego de que el usuario deja de ecsribir
};

export default HandleUpdateText